import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export const customAlert = (data, emit = null) => {
    switch (data.type) {
        case 1:
            Swal.fire({
                icon: "success",
                title: data.title,
                text: data.subtitle,
                showConfirmButton: true,
                timer: data.timer || 1000,
            }).then(() => {
                if (data.redirect) window.location = data.redirect;
                if (data.reload) location.reload();
            });
            break;
        case 2:
            Swal.fire({
                icon: "warning",
                title: data.title,
                text: data.subtitle,
                showConfirmButton: true,
            });
            break;
        case 3:
            Swal.fire({
                icon: "error",
                title: data.title,
                text: data.subtitle,
                showConfirmButton: true,
            });
            break;
        case 4:
            Swal.fire({
                icon: "warning",
                title: data.title,
                text: data.subtitle,
                showCancelButton: true,
                confirmButtonText: data.confirmMsg || "¡Sí, eliminar!",
                cancelButtonText: data.cancelMsg || "¡No, cancelar!",
            }).then((result) => {
                if (result.value) {
                    !!data.callback && data.callback();
                }
            });
            break;
        case 5:
            Swal.fire({
                icon: "success",
                title: data.title,
                text: data.subtitle,
                showConfirmButton: true,
                timer: data.timer || 1000,
            }).then(() => {
                !!emit && emit(data.event);
            });
            break;
        default:
            console.log(data);
            break;
    }
};